/** Returns a Google Maps search URL for a selected or saved dining place. */
export function diningMapUrl({ name = '', address = '', googlePlaceId = '' } = {}) {
  const query = [name, address].map((part) => part.trim()).filter(Boolean).join(', ');
  if (!query) return null;
  const url = new URL('https://www.google.com/maps/search/');
  url.searchParams.set('api', '1');
  url.searchParams.set('query', query);
  if (googlePlaceId) url.searchParams.set('query_place_id', googlePlaceId);
  return url.toString();
}
